import { render, staticRenderFns } from "./CheckoutStep2.vue?vue&type=template&id=05212af4"
import script from "./CheckoutStep2.vue?vue&type=script&lang=js"
export * from "./CheckoutStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/home/gitlab-runner/builds/_LQxgyuP/0/skolkovo/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardHeader, BForm, BFormCheckbox, BFormInvalidFeedback, BFormGroup, BCardBody, BCollapse, BCard, BSpinner, BButton, BModal} from 'bootstrap-vue'
    installComponents(component, {BCardHeader, BForm, BFormCheckbox, BFormInvalidFeedback, BFormGroup, BCardBody, BCollapse, BCard, BSpinner, BButton, BModal})
    


    import installDirectives from "!/home/gitlab-runner/builds/_LQxgyuP/0/skolkovo/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBToggle, VBPopover} from 'bootstrap-vue'
    installDirectives(component, {'b-toggle': VBToggle, 'b-popover': VBPopover})
    

export default component.exports